import React from 'react';
import {get} from 'lodash';

const NUMBERONLY_DEFAULT_PLACEHOLDER = '';
const NUMBERONLY_DEFAULT_MAX_LENGTH = 10;


export default (props) => {
    if (props.is_preview) {
        return renderReadOnlyField(props);
    } else {
        return renderInputField(props);
    }
}


const renderInputField = (props) => {
    const maxLength = get(props.component_data, 'config.max_length', NUMBERONLY_DEFAULT_MAX_LENGTH);
    const value = get(props.answer, ['answer_selections', props.inputKey], '');
    const style = get(props.itemData, 'style');
    const placeholder = get(props.itemData, 'placeholder', NUMBERONLY_DEFAULT_PLACEHOLDER);

    return (
        <input
            className="cc-numberonly-item-input"
            type="text"
            value={value ?? ''}
            placeholder={placeholder}
            onChange={props.onChange}
            maxLength={maxLength}
            style={style}
        />
    )
}

const renderReadOnlyField = (props) => {
    const style = get(props.itemData, 'style');
    const placeholder = get(props.itemData, 'placeholder', NUMBERONLY_DEFAULT_PLACEHOLDER);

    const getContent = () => {
        if (props.existing_answer) {
            return get(props.existing_answer, ['data', 'answer', 'answer_selections', props.inputKey]);
        } else {
            return (
                <span className="cc-numberonly-item-readonly-placeholder">
                    {placeholder}
                </span>
            )
        }
    }

    return (
        <div className="cc-numberonly-item-readonly" style={style}>
            {getContent()}
        </div>
    )
}